'use client';

import { useClientSide } from '@carvana/merch-react-hooks';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useContext, useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';
import { assetsCdnUrl, commonEnvironment } from '~/constants/environment';
import StaticContext from '~/context/common/StaticContext';
import { wait } from '~/utilities';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

type OwnProps = {
  className?: string;
};

function PageFooter({ className }: OwnProps) {
  const { removeFooter } = useContext(StaticContext);
  const isClientSide = useClientSide();

  useEffect(() => {
    if (removeFooter) return;

    wait(100).then(() => {
      void MfeLoad({
        files: [
          [
            'FooterModule',
            [
              {
                component: 'default',
                browser: true,
                default: {
                  file: 'index.js',
                  manifest: `${assetsCdnUrl}/footer/module/assets-manifest.json?v=${getMfeCacheBuster()}`
                }
              }
            ]
          ]
        ]
      });
    });
  }, [removeFooter]);

  if (removeFooter) return null;

  return isClientSide ? (
    <MfeReactComponent
      component="default"
      module="FooterModule"
      environment={commonEnvironment}
      withoutProvider
      wrapperClassName={className}
    />
  ) : null;
}

export default withErrorBoundary(PageFooter, { section: 'PageFooter' });
